export enum COMMON_USER_NOTIFICATION_DIALOG_EVENTS {
	CLOSE_DIALOG = 'CLOSE_DIALOG',
}
